<!-- 新闻动态 -->
<template>
	<div class="news" id="news">
		<div class="container">
			<div class="wthree-heading">
				<h3>新闻动态</h3>
				<h4>N</h4>
				<p class="color-gray">news</p>
			</div>
			<div class="min_height_500 padding_vertical_20">
				<div class="line_height_50 border_left_title">
					<span class="font_size_20 font_weight color-a">最新动态</span>
					<span class="pull-right">
						<!-- 跳转新闻列表页 -->
						<router-link tag="a" target="_blank" :to="{name:'news'}">更多 <i class="fa fa-angle-right"></i></router-link>
						<!-- <a href="/news" target="_blank">更多 <i class="fa fa-angle-right"></i></a> -->
					</span>
				</div>
				<hr>
				<div class="news-list" id="newsList">
					<router-link tag="a" target="_blank" v-for="item in arrData" :key="item.newsid" :to="{name:'news', query: { newsid: item.newsid }}">
						<!-- <router-link tag="a" target="_blank" v-for="item in arrData" :key="item.newsid" :to="{name:'news', params: { newsid: item.newsid }}"> -->
						<!-- <a v-for="item in arrData" :key="item.newsid" :href="'../html/newsdetail.html?newsid=' + item.newsid" target="_blank"> -->
						<div class="news-list-item">
							<h3 class="news-title">{{item.title}}</h3>
							<p class="news-synopsis">{{item.synopsis}}</p>
							<p class="news-time">文章来源：<span>{{item.source}}</span><span>{{item.time}}</span></p>
						</div>
						<!-- </a> -->
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "News",
		data() {
			return {
				arrData: [] //所有新闻
			}
		},
		mounted: function() {
			//获取新闻列表
			this.$axios.get('/new/list').then(res => {
				if (res.status == 200 && res.data) {
					//过滤出允许显示和在首页显示的新闻
					const arrNewsList = res.data.filter(function(item, index) {
						return item.isshow && item.isshowhome;
					});
					this.arrData = arrNewsList.slice(0, 10);
				} else {
					this.$message('新闻列表获取失败！');
				}
			});
			// //获取新闻列表
			// const arrNews = require('../assets/news/news2018.json');
			// //过滤出允许显示和在首页显示的新闻
			// const arrNewsList = arrNews.filter(function(item, index) {
			// 	return item.isshow && item.isshowhome;
			// });
			// this.arrData = arrNewsList.slice(0, 10);
		}
	}
</script>

<style>
</style>
